
import React from 'react';

function EsteiraComponent(props) {
	const { step } = props;

	return (
		<div className='esteira'>
			<div className={`${step >= 1 ? 'complete' : 'not-complete'}`} />
			<div className={`${step >= 2 ? 'complete' : 'not-complete'}`} />
			<div className={`${step >= 3 ? 'complete' : 'not-complete'}`} />
			<div className={`${step >= 4 ? 'complete' : 'not-complete'}`} />
		</div>
	);
}

export default EsteiraComponent;
